module.exports = __webpack_public_path__ + "img/wallet_02_qris_1.d7094cb7.png";